<template>
  <b-container fluid>
    <b-row>
      <!-- left part of page with content -->
      <b-col cols="12" sm="9" md="8">
        <b-row class="mb-3">
          <b-col>
            <h3>
              <b-badge variant="primary">
                Status of Household
              </b-badge>
              <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
            </h3>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Household ID: </b-col>
          <b-col>{{ HHID }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Family Name: </b-col>
          <b-col>{{ FamilyName }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Claim ID: </b-col>
          <b-col>{{ ClaimID }}</b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table 
              small
              responsive
              class="mt-4"
              :busy="waiting"
              :tbody-tr-class="rowClass"
              :items="statusTable.items" 
              :fields="statusTable.fields">
              <div slot="table-busy" class="text-center text-danger">
                <b-spinner class="align-middle"></b-spinner>
                <!-- <strong>Loading...</strong> -->
              </div>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
      <!-- right part of page with buttons -->
      <b-col cols="12" sm="3" md="4" class="pt-sm-0 pt-2">
        <b-row no-gutters>
          <b-col>
            <b-button 
              block 
              class="pb-3 pt-3 mb-2 mt-2"
              @click="$router.go(-1)">
              Back
            </b-button>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-button 
              block 
              class="pb-3 pt-3 mb-2 mt-2"
              @click="$router.push({path: `/householdvisits/${HHID}`})">
              Visit History
            </b-button>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-button 
              block 
              class="pb-3 pt-3 mb-2 mt-2"
              @click="$router.push({path: `/householdnotes/${HHID}`})">
              Notes
            </b-button>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-button 
              block 
              class="mb-2 mt-2"
              @click="$router.push({path: `/household/${HHID}`})">
              Status of household members
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'HouseholdStatus',
  data() {
    return {
      waiting: false,
      HHID: '',
      FamilyName: '',
      ClaimID: '',
      statusTable: {
        items: [],
        fields: [
          {
            key: 'StatusDescription',
            label: 'ST Status of Household'
          }
        ]
      }
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    let vm = this
    this.waiting = true
    // populate page
    apiService.getHouseholdStatus(this.HHID)
    .then((response) => {
      vm.FamilyName = response.data.FamilyName
      vm.ClaimID = response.data.ClaimID
      //populate table
      vm.statusTable.items = response.data.Statuses
      vm.waiting = false
    })
  },
  methods: {
    rowClass(item, type) {
      if (!item) return
      if (item.StatusOfHousehold === 0) {
        return 'table-danger'
      } else if (item.StatusOfHousehold === 1) {
        return 'table-success'
      } else {
        console.log('invalid StatusOfHousehold value in table')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/HouseholdStatusPage.vue